import { render, staticRenderFns } from "./TraineeList.vue?vue&type=template&id=5096aa8c&"
import script from "./TraineeList.vue?vue&type=script&lang=js&"
export * from "./TraineeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports